import { SignedRevision } from "../models/signedRevision";
import BlockchainApiService from "../services/blockchainApi";

export const signRevision = async (signedRevision: Partial<SignedRevision>): Promise<boolean> => {
  const apiService = new BlockchainApiService();
  try {
    const response = await apiService.post<any>(`/signed-revision/v1/reviews`, signedRevision);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getSignedRevisions = async (chassis: string): Promise<SignedRevision[]> => {
    const apiService = new BlockchainApiService();
    try {
        const response = await apiService.get<any>(`/signed-revision/v1/reviews`, { params: {chassis} });
        return response.status >= 200 && response.status < 300 ? response.data as SignedRevision[] : [];
    } catch (error) {
        console.error(error);
        return [];
    }
};
